import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';
import {
  CustomerDataEventInteractiveActions,
  CustomerDataEventInteractiveCategories,
  type CustomerDataEventsType
} from '@/modules/shared/utils/gtmEvents/customerDataTypes';

import { sendGtmEvent } from '../Manager';

import { PERSONAL_DETAILS_ACTION_FIELD } from './constants';
import { getProductMapEvent } from './utils';

const CustomerDataEvents: CustomerDataEventsType = {
  baseEvent: {
    'event-interactive-category':
      CustomerDataEventInteractiveCategories.Checkout,
    'event-interactive-accion': CustomerDataEventInteractiveActions.Click,
    event: 'event-interactive'
  }
};

export function sendPageVirtual() {
  sendGtmEvent({
    event: 'page-virtual',
    page: window.location.pathname,
    pagename: 'Buying Process - Identification'
  });
}

export function getProductMapForPageView(products: CartLineItem[]) {
  return {
    event: 'checkout',
    'type-User': 'guest',
    ecommerce: {
      checkout: {
        actionField: PERSONAL_DETAILS_ACTION_FIELD,
        products: products.map(getProductMapEvent)
      }
    }
  };
}

export const sendIdentifyPageViewGTMEvent = (
  productsGtmInfo: CartLineItem[]
): void => {
  const gtmSendPageView = getProductMapForPageView(productsGtmInfo);
  sendGtmEvent(gtmSendPageView);
};

export default CustomerDataEvents;
